/**
 * TempoSupply – Mengenrabatt-Preise im Warenkorb (Side-Cart + Cart-Page)
 * Liest LPO-Line-Item-Properties und aktualisiert Anzeige-Preise + Summen.
 */
(function () {
  'use strict';

  var PROP_ID = '_cl_options_quantity_id';
  var PROP_DISCOUNT = '_cl_options_quantity_discount';
  var refreshTimer = null;

  function formatMoney(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return amount + '\u00a0€';
  }

  function parseTiers(discountStr) {
    if (!discountStr) return [];

    return discountStr.split(',').map(function (part) {
      var pieces = part.split(':');
      if (pieces.length < 2) return null;

      var minQty = parseInt(pieces[0], 10);
      var raw = pieces[1];
      var isPercent = raw.indexOf('%') !== -1;
      var value = parseFloat(raw);

      if (isNaN(minQty) || isNaN(value)) return null;

      return {
        minQty: minQty,
        discount: value,
        priceType: isPercent ? 'percent' : 'absolute'
      };
    }).filter(Boolean);
  }

  function selectTier(tiers, totalQty) {
    var selected = null;

    tiers.forEach(function (tier) {
      if (totalQty >= tier.minQty) {
        if (!selected || tier.minQty > selected.minQty) {
          selected = tier;
        }
      }
    });

    return selected;
  }

  function calcDiscountedLineCents(item, tier) {
    var unitCents = item.original_price || item.price;
    var qty = item.quantity;
    var originalLine = unitCents * qty;

    if (!tier) {
      return {
        original: originalLine,
        final: item.final_line_price != null ? item.final_line_price : originalLine
      };
    }

    var discountedUnit;

    if (tier.priceType === 'percent') {
      discountedUnit = Math.round(unitCents * (1 - tier.discount / 100));
    } else {
      discountedUnit = Math.max(0, unitCents - Math.round(tier.discount * 100));
    }

    return {
      original: originalLine,
      final: discountedUnit * qty
    };
  }

  function buildGroups(items) {
    var groups = {};
    var standalone = [];

    items.forEach(function (item) {
      var props = item.properties || {};
      var groupId = props[PROP_ID];
      var discountStr = props[PROP_DISCOUNT];

      if (!groupId || !discountStr) {
        standalone.push(item);
        return;
      }

      if (!groups[groupId]) {
        groups[groupId] = {
          tiers: parseTiers(discountStr),
          items: [],
          totalQty: 0
        };
      }

      groups[groupId].items.push(item);
      groups[groupId].totalQty += item.quantity;
    });

    return { groups: groups, standalone: standalone };
  }

  function updateItemDom(item, originalCents, finalCents) {
    var nodes = document.querySelectorAll('[data-live-item-key="' + item.key + '"]');

    nodes.forEach(function (node) {
      var finalEl =
        node.querySelector('[data-live-item-final-line-price]') ||
        node.querySelector('[data-live-item-final-line-price-discount]');
      var originalEl =
        node.querySelector('[data-live-item-original-line-price]') ||
        node.querySelector('.ts-lpo-original');

      if (!finalEl) {
        var priceBlocks = node.querySelectorAll('.price.s1pr');
        priceBlocks.forEach(function (block) {
          if (!finalEl) {
            finalEl = document.createElement('span');
            finalEl.setAttribute('data-live-item-final-line-price', '');
            block.appendChild(finalEl);
          }
        });
      }

      if (!originalEl && finalCents < originalCents) {
        var priceWrap = node.querySelector('.price.s1pr');
        if (priceWrap && finalEl) {
          originalEl = document.createElement('span');
          originalEl.className = 'old-price ts-lpo-original';
          originalEl.setAttribute('data-live-item-original-line-price', '');
          priceWrap.insertBefore(originalEl, finalEl);
        }
      }

      if (finalEl) {
        finalEl.textContent = formatMoney(finalCents);
      }

      if (originalEl) {
        if (finalCents < originalCents) {
          originalEl.textContent = formatMoney(originalCents);
          originalEl.classList.remove('hidden');
          originalEl.style.display = '';
          node.classList.add('has-discount');
        } else {
          originalEl.classList.add('hidden');
          node.classList.remove('has-discount');
        }
      }
    });
  }

  function updateTotals(subtotalCents, totalCents) {
    document.querySelectorAll('[data-live-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(subtotalCents);
    });

    document.querySelectorAll('[data-live-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(totalCents);
    });
  }

  function applyCart(cart) {
    if (!cart || !cart.items) return;

    var parsed = buildGroups(cart.items);
    var subtotal = 0;

    parsed.standalone.forEach(function (item) {
      var prices = calcDiscountedLineCents(item, null);
      subtotal += prices.final;
      updateItemDom(item, prices.original, prices.final);
    });

    Object.keys(parsed.groups).forEach(function (groupId) {
      var group = parsed.groups[groupId];
      var tier = selectTier(group.tiers, group.totalQty);

      group.items.forEach(function (item) {
        var prices = calcDiscountedLineCents(item, tier);
        subtotal += prices.final;
        updateItemDom(item, prices.original, prices.final);
      });
    });

    var total = subtotal;

    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      cart.cart_level_discount_applications.forEach(function (discount) {
        total -= discount.total_allocated_amount || 0;
      });
    }

    updateTotals(subtotal, total);
  }

  function refresh() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(applyCart)
      .catch(function () {});
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 150);
  }

  window.TsLpoCart = {
    refresh: refresh,
    scheduleRefresh: scheduleRefresh
  };

  document.addEventListener('DOMContentLoaded', scheduleRefresh);
  window.addEventListener('listCart', scheduleRefresh);
  window.addEventListener('cloudlift.options.ready', scheduleRefresh);

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (url && /\/cart(\/|\.js|\/add|\/change|\/update)/.test(url)) {
          scheduleRefresh();
        }
        return response;
      });
    };
  }
})();
